import { Injectable } from '@angular/core';
import {NeoStorageService} from "ng-neo/index";
import {Token} from "../../models/token";

@Injectable()
export class NeoJWTService {

    constructor(
        private _storage: NeoStorageService
    ) { }

    /**
     * Obtiene el token actual
     * @returns {any}
     */
    getToken(): Token {
        return new Token(this._storage.getFromLocalStorage('token'));
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/neo-jwt/neo-jwt.ts